<template>
  <div></div>
</template>

<script>
import pingpp from 'pingpp-js'
import api from '../../../api'
export default {
  name: 'WxCode',
  data () {
    return {
    }
  },
  mounted () {
    api.getWxCode({
      data: {
        order_no: this.order_no,
        code: this.code,
        product_type: this.product_type
      }
    }).then(res => {
      let data = res.data
      if (data.code === 1) {
        pingpp.createPayment(data.data, (result, error) => {
          if (result === 'success') {
            this.$router.push({
              name: 'checkoutSuccess',
              query: {
                order_no: this.order_no
              }
            })
          } else {
            this.$router.push({
              name: 'payPage',
              params: {
                order_no: this.order_no
              }
            })
          }
        })
      } else {
        alert(data.error)
        this.$router.push({
          name: 'payPage',
          params: {
            order_no: this.order_no
          }
        })
      }
    }, err => {
      alert(err)
      this.$router.push({
        name: 'payPage',
        params: {
          order_no: this.order_no
        }
      })
    })
  },
  computed: {
    order_no () {
      return this.$route.query.order_no
    },
    code () {
      return this.$route.query.code
    },
    product_type () {
      return this.$route.query.product_type
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
